import { TFunction } from 'i18next';
import _ from 'lodash';
import {
  ItemStatsMetric,
  ItemStatsMetricDescriptorBase,
} from './itemStatsMetric.types';

export const getItemStatsMetricDescriptors = (
  t: TFunction<'app'>,
): ItemStatsMetricDescriptorBase[] => [
  {
    type: 'categoryABC',
    path: 'categoryABC',
    rangeType: 'distinct',
    bucketSortPriorities: ['D', 'C', 'B', 'A', 'A+'],
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'orderLineCount',
    path: 'orderLineCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'orderLineCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'orderLineCount',
    path: 'orderLineCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'orderLineCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'quantityOrdered',
    path: 'quantityOrdered',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'quantityOrdered',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'percentRank',
    path: 'percentRank',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'percentRank',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'cumulativePercentRank',
    path: 'cumulativePercentRank',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'cumulativePercentRank',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'totalDaysOrdered',
    path: 'totalDaysOrdered',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'totalDaysOrdered',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'totalWeeksOrdered',
    path: 'totalWeeksOrdered',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'totalWeeksOrdered',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'maxDailyLinesCount',
    path: 'maxDailyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'maxDailyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'minDailyLinesCount',
    path: 'minDailyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'minDailyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'avgDailyLinesCount',
    path: 'avgDailyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'avgDailyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'maxWeeklyLinesCount',
    path: 'maxWeeklyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'maxWeeklyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'minWeeklyLinesCount',
    path: 'minWeeklyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'minWeeklyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'avgWeeklyLinesCount',
    path: 'avgWeeklyLinesCount',
    rangeType: 'range-linear',
    aggregationFn: 'max',
    aggregateBy: 'avgWeeklyLinesCount',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
];

export const getItemStatsMetricDescriptorsMap = (t: TFunction<'app'>) =>
  _.keyBy(getItemStatsMetricDescriptors(t), d => d.type) as Record<
    ItemStatsMetric,
    ItemStatsMetricDescriptorBase
  >;
